import axios from 'axios'
import wx from 'weixin-js-sdk'

export default function(link, title, desc, imgUrl) {
  axios.post('https://www.shanghaimuseum.net/mu/frontend/pg/get-weixin-js-api-signature', {
    url: link
  }).then(function(response) {
    if (response.data.code == 0) {
      const result = response.data.data
      wx.config({
        debug: false,
        appId: result.appid,
        timestamp: result.timestamp,
        nonceStr: result.noncestr,
        signature: result.signature,
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData'
        ]
      })
      wx.ready(function() {
        wx.updateAppMessageShareData({
          link,
          title,
          desc,
          imgUrl
        })
        wx.updateTimelineShareData({
          link,
          title,
          imgUrl
        })
      })
    }
  })
}
